// extracted by mini-css-extract-plugin
export var phone = "_3l-0";